'use client';

/**
 * NotFoundBody — client island for the 404 page. A not-found file receives no
 * route params, so the locale is derived from the URL (useLang) to keep the
 * human sentences and the "return home" link localized.
 */

import Link from 'next/link';
import { useLang } from '@/i18n/client';
import { localePath, type Lang } from '@/i18n/config';
import p from './pages.module.css';

const copy: Record<Lang, { h1: string; lead: string; home: string }> = {
  en: {
    h1: 'This coordinate does not exist',
    lead: 'Nothing is anchored at this address. The laboratory itself is still online.',
    home: 'Return to the core',
  },
  ru: {
    h1: 'Такой координаты не существует',
    lead: 'По этому адресу ничего не закреплено. Сама лаборатория по-прежнему в сети.',
    home: 'Вернуться в ядро',
  },
};

export default function NotFoundBody() {
  const lang = useLang();
  const t = copy[lang];

  return (
    <div className={`wrap ${p.lost}`}>
      <p className="machine">
        <span className="status-dot" aria-hidden="true" /> STUDYLAB / SIGNAL
        LOST
      </p>
      <p className={p.lostCode} aria-hidden="true">
        404
      </p>
      <h1>{t.h1}</h1>
      <p className="lead">{t.lead}</p>
      <Link href={localePath(lang, '/')} className="btn">
        {t.home}
      </Link>
    </div>
  );
}
